var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.467 2.068A5.306 5.306 0 0 1 17.2 6.291a.6.6 0 0 1-1.176.238 4.106 4.106 0 0 0-7.07-1.935A4.1 4.1 0 0 0 7.895 7.35v3.164h10.691c1.37 0 2.482 1.111 2.482 2.482v6.587c0 1.37-1.111 2.481-2.482 2.481H5.413a2.48 2.48 0 0 1-2.481-2.481v-6.587a2.48 2.48 0 0 1 2.481-2.482h1.283V7.35a5.305 5.305 0 0 1 4.771-5.282m-6.054 9.646c-.707 0-1.282.574-1.282 1.282v6.587c0 .707.575 1.28 1.282 1.281h13.173c.708 0 1.282-.573 1.283-1.281v-6.587c0-.708-.575-1.282-1.283-1.282H5.413"
  })));
};
export default SvgUnlock;